import axios from 'axios'
import qs from "qs"
import config from "./config.json"

export default {
  install(Vue) {
    Vue.prototype.$config = config;
    Vue.prototype.commonTipsError = function (result) {
      this.$message({
        message: result,
        type: "error",
        duration:1000
      });
    };
    Vue.prototype.commonTipsSuccess = function (result) {
      this.$message({
        message: result,
        type: "success",
        duration:1000
      });
    };
    Vue.prototype.commonTips = function (result) {
      this.$message({
        message: result,
        duration:1000
      });
    };
    Vue.prototype.commonConfirm = function (result) {
      return this.$confirm(result, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
    };
    Vue.prototype.commonEncryptCode = function (result) {
      var encryptcode = this.$crypto.AES.encrypt(result, localStorage.getItem('parkToken')).toString();
      return encodeURIComponent(encryptcode);
    };
    Vue.prototype.commonDecryptCode = function (result) {
      var decryptcode = decodeURIComponent(result);
      decryptcode = this.$crypto.AES.decrypt(decryptcode, localStorage.getItem('parkToken')).toString(this.$crypto.enc.Utf8)
      return decryptcode;
    };
    Vue.prototype.setUserLog = function (page,action) {
          let params = qs.stringify({
            Page: page,
            Action: action
          });
          axios.post("/Api/SetUserLog", params)
          .then(function(response) {
            let res = response.data;
            console.log(res.data);
          })
          .catch(function(error) {
            console.log(error);
          });
    };
    // //防抖
    // Vue.prototype.debounce = function (fn, wait) {
    //   console.log(wait)
    //   let timeout = null
    //   return function () {
    //     if (timeout !== null) clearTimeout(timeout)
    //     timeout = setTimeout(fn, wait);
    //   }
    // }
    // //节流
    // Vue.prototype.throttle = function () {
    //   let that = this
    //   let now = +new Date();
    //   if (lastTime && lastTime - now < 1000) {
    //     clearTimeout(timer)
    //   }
    //   timer = setTimeout(function () {
    //     console.log('点击')
    //     lastTime = +new Date()
    //   }, 200)
    // }
    Vue.directive('log', {
      bind: function (el, binding, vnode, oldVnode) {
        el.addEventListener('click', function () {
          //binding.value为所传的参数
          // console.log(el, binding.value);
          // console.log(axios)
          let obj =binding.value;
          let params = qs.stringify({
            Page: obj.page,
            Action: obj.action
          });
          // axios.post("/Api/SetUserLog", params)
          // .then(function(response) {
          //   let res = response.data;
          //   console.log(res.data);
          // })
          // .catch(function(error) {
          //   console.log(error);
          // });
        })
      }
    })

  }
}



// WEBPACK FOOTER //
// ./src/common/common.js